<template>
    <div class="trading-desk-container portfolio-wrapper">
        <v-layout column wrap fill-height>
            <div class="loading-screen" v-if="isLoading">
                <v-img class="loading-gif" src="../assets/loading.gif"></v-img>
            </div>

            <div class="trading-desk-container1" v-if="!isLogged">
                <div class="wine-market-wrapper">
                    <h3>My portfolio</h3>
                    <div class="no-fav">
                        <div>Join Vindome to start building your collection of favourite wines</div>
                        <button class="btn-primary goto-market-btn" v-on:click="() => goToLogin()">Join Vindome</button>
                    </div>
                </div>
            </div>

            <div class="trading-desk-container1" v-if="isLogged">
                <div class="wine-market-wrapper">
                    <div class="gift-btn" v-on:click="giftModal=true">
                        {{ $t('myportfolio7') }}
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path
                                d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"/>
                        </svg>
                    </div>

                    <div class="my-investments">
                        <div class="investments-item">
                            <div class="investments-label">{{ $t('initial-investment') }}</div>
                            <div class="bold">{{
                                    newPortfolioSummary.investmentAmount ? formatPrice(newPortfolioSummary.investmentAmount.toLocaleString("fi-FI", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }).replace(',', '.')) : 0
                                }}
                            </div>
                        </div>
                        <div class="investments-item">
                            <div class="investments-label">{{ $t('market-value') }}</div>
                            <div class="bold">{{
                                    newPortfolioSummary.marketValue ? formatPrice(newPortfolioSummary.marketValue.toLocaleString("fi-FI", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }).replace(',', '.')) : 0
                                }}
                            </div>
                        </div>
                        <div class="investments-item">
                            <div class="investments-label">{{ $t('performance') }}</div>
                            <div class="rate-wrapper">
                                <div class="bold">{{
                                        newPortfolioSummary.performanceAmount ? formatPrice(newPortfolioSummary.performanceAmount.toLocaleString("fi-FI", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).replace(',', '.')) : 0
                                    }}
                                </div>
                                <div class="regular">{{
                                        newPortfolioSummary.performanceRate ? newPortfolioSummary.performanceRate.toLocaleString("fi-FI", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).replace(',', '.') : 0
                                    }}%
                                </div>
                                <div class="performance down" v-if="newPortfolioSummary.performanceRate < 0"></div>
                                <div class="performance up"></div>
                            </div>
                        </div>
                        <div class="investments-item total-gain">
                            <div class="investments-label">{{ $t('bottles-owned') }}</div>
                            <div class="bold">{{
                                    newPortfolioSummary.bottlesOwnedNow ? newPortfolioSummary.bottlesOwnedNow.toLocaleString("fi-FI", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    }).replace(',', '.') : 0
                                }}
                            </div>
                        </div>
                    </div>

                    <div v-if="wineList.length > 0">
                        <v-row v-for="portfolioItem in wineArray" :key="portfolioItem.wineId" no-gutters
                               class="portfolio-row">
                            <div class="wine-details-head">
                                <div v-if="portfolioItem.wineName">
                                    <h2 v-on:click="() => goToWineDetails(portfolioItem)">{{ portfolioItem.vintage }}
                                        {{ portfolioItem.wineName }}</h2>
                                    <h3 v-if="portfolioItem.isSecondLabel" class="addition-description">2-nd label of
                                        {{ portfolioItem.producerTypeName }} {{ portfolioItem.producerName }}</h3>
                                    <h3 v-else class="addition-description">{{ portfolioItem.producerTypeName }}
                                        {{ portfolioItem.producerName }}</h3>
                                </div>
                                <div v-else>
                                    <h2 v-on:click="() => goToWineDetails(portfolioItem)">{{ portfolioItem.vintage }}
                                        {{ portfolioItem.producerTypeName }} {{ portfolioItem.producerName }}</h2>
                                </div>
                                <div v-if="portfolioItem.isEnPrimeur" class="wine-enprimeur">
                                    En Primeur
                                    <div class="info-text">{{ $t('will-be-bottled') }}{{portfolioItem.vintage.charAt(2)}}{{parseInt(portfolioItem.vintage.charAt(3)) + 3}}</div>
                                </div>
                                <div class="wine-summary-wrapper">
                                    <div class="wine-summary-row">
                                        <div class="wine-summary-row-title">{{ $t('initial-investment') }}</div>
                                        <div class="wine-summary-row-value">{{ currencySign }}{{
                                                portfolioItem.marketValue.investmentAmount.toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.')
                                            }}
                                        </div>
                                    </div>
                                    <div class="wine-summary-row">
                                        <div class="wine-summary-row-title">{{ $t('market-value') }}</div>
                                        <div class="wine-summary-row-value">{{ currencySign }}{{
                                                portfolioItem.marketValue.marketValue.toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.')
                                            }}
                                        </div>
                                    </div>
                                    <div class="wine-summary-row">
                                        <div class="wine-summary-row-title">{{ $t('performance') }}</div>
                                        <div class="wine-summary-row-value">
                                            <div class="wine-summary-row-value1">{{ currencySign }}{{
                                                    portfolioItem.marketValue.performanceAmount.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.')
                                                }}
                                            </div>
                                            <div class="wine-summary-row-value2" style="color: rgba(0, 0, 0, 0.64);">{{
                                                    portfolioItem.marketValue.performanceRate.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.')
                                                }}%
                                            </div>
                                            <div class="wine-summary-row-value3 down"
                                                 v-if="portfolioItem.marketValue.performanceRate < 0"></div>
                                            <div class="wine-summary-row-value3 up" v-else></div>
                                        </div>
                                    </div>
                                    <div class="wine-summary-row">
                                        <div class="wine-summary-row-title">{{ $t('bottles') }}</div>
                                        <div class="wine-summary-row-value">
                                            {{ portfolioItem.marketValue.numberOfBottles }}
                                        </div>
                                    </div>
                                    <div class="wine-summary-row last-child">
                                        <div class="perform-btn"
                                             v-on:click="() => openWinePerformance('', portfolioItem)">
                                            {{ $t('wine-performance') }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mobile-wines-header" :class="{de: $i18n.locale === 'de', it: $i18n.locale === 'it'}">
                                <div>{{ $t('case-size') }}</div>
                                <div>{{ $t('myportfolio3') }}</div>
                                <div>{{ $t('myportfolio5') }}</div>
                                <div>{{ $t('myportfolio6') }}</div>
                                <div>Favourites</div>
                                <div></div>
                            </div>
                            <div class="mobile-wines-body">
                                <div v-for="(item, index) in portfolioItem.casesSizes" :key="index">
                                    <div class="mobile-wines-row" v-if="portfolioItem.wineId === item.wineId">
                                        <div class="mobile-wines-div">{{ item.size }}</div>
                                        <div class="mobile-wines-div">{{ item.owned }}</div>
                                        <div class="mobile-wines-div">{{ item.bidsCases }}</div>
                                        <div class="mobile-wines-div">{{ item.offersCases }}</div>
                                        <div class="mobile-wines-div">
                                            <button v-on:click="(event) => toggleFav(event, item)"
                                                    :class="item.isFavourite ? 'wine-star active' : 'wine-star'"></button>
                                        </div>
                                        <div class="mobile-wines-div"></div>
                                        <div class="mobile-wines-div cta-button left">
                                            <div class="btn-secondary market-btn"
                                                 v-on:click="() => selectWine(item, false)">{{ $t('sell') }}
                                            </div>
                                        </div>
                                        <div class="mobile-wines-div cta-button right">
                                            <div class="btn-secondary market-btn ga4-buy-wine"
                                                 v-on:click="() => selectWine(item, true)">{{ $t('buy') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-row>
                    </div>
                    <div class="no-orders-info" v-if="wineList.length == 0">{{ $t('no-investments') }}</div>
                </div>
            </div>

            <v-dialog v-model="giftModal" max-width="570px">
                <v-card class="bids-offers-modal">
                    <div class="gift-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path
                                d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"/>
                        </svg>
                    </div>

                    <v-card-text class="cancel-bid-body" v-if="!activationSuccessful && !activationError">
                        <h3>{{ $t('myportfolio7') }}</h3>
                        <v-text-field class="gift-code" :placeholder="$t('myportfolio8')"
                                      v-model="giftCode"></v-text-field>
                    </v-card-text>
                    <v-card-text class="cancel-bid-body" v-if="activationSuccessful && !activationError">
                        <h3>Congratulations!<br/>You added a gift to your portfolio.</h3>
                    </v-card-text>
                    <v-card-text class="cancel-bid-body" v-if="!activationSuccessful && activationError">
                        <h3>Activation failed!<br/>Please enter a valid gift code.</h3>
                    </v-card-text>

                    <v-card-actions v-if="!activationSuccessful && !activationError">
                        <v-btn class="btn-primary btn-bid-proceed" text v-on:click="activateGift"
                               :disabled="giftCode == ''">{{ $t('myportfolio9') }}
                        </v-btn>
                        <v-btn class="btn-secondary btn-bid-cancel" text v-on:click="resetGiftModal(true)">
                            {{ $t('cancel') }}
                        </v-btn>
                    </v-card-actions>
                    <v-card-actions v-if="activationSuccessful && !activationError">
                        <v-btn class="btn-primary btn-bid-proceed" text v-on:click="resetGiftModal(true)">View
                            portfolio
                        </v-btn>
                    </v-card-actions>
                    <v-card-actions v-if="!activationSuccessful && activationError">
                        <v-btn class="btn-primary btn-bid-proceed" text v-on:click="resetGiftModal(false)">Try again
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {GCommon, GPortfolio, GWines} from '@/store/getters';
import {APortfolio, AOrders, AWines, AUser} from '@/store/actions';
import moment from 'moment';

export default {
    name: "Portfolio",
    data() {
        return {
            isLoading: false,
            isLogged: false,
            giftModal: false,
            cancelBidId: null,
            giftCode: '',
            activationSuccessful: false,
            activationError: false
        }
    },
    computed: {
        ...mapGetters({
            wineList: GPortfolio.GET_PORTFOLIO_WINE_LIST,
            portfolioValue: GPortfolio.GET_PORTFOLIO_VALUE,
            newPortfolioSummary: GPortfolio.GET_NEW_PORTFOLIO_SUMMARY,
            portfolioProfit: GPortfolio.GET_PORTFOLIO_TOTAL_PROFIT,
            portfolioSummary: GPortfolio.GET_PORTFOLIO_SUMMARY,
            favWinesList: GWines.GET_FAVOURITE_WINES,
            currencySign: GCommon.GET_CURRENCY_SIGN,
        }),
        filteredItems() {
            return this.portfolioSummary.map(item => {
                let isWineInFavourites = false;

                this.favWinesList.forEach(wine => {
                    if (item.wineId === wine.wineId && item.caseSizeId === wine.caseSizeId) {
                        isWineInFavourites = true;
                    }
                });
                return Object.assign({isFavourite: isWineInFavourites}, item);
            })
        },
        wineArray() {
            let sortedWines = [];
            let sortedWinesIds = [];
            let arrayIndex = 0;

            this.portfolioSummary.map(el => {
                let currWineIndex = sortedWinesIds.indexOf(el.portfolioSummary[0].wineId);
                if (currWineIndex === -1) {
                    sortedWinesIds.push(el.portfolioSummary[0].wineId);
                    sortedWines[arrayIndex] = {};

                    sortedWines[arrayIndex].wineId = el.portfolioSummary[0].wineId;
                    sortedWines[arrayIndex].wine = el.portfolioSummary[0].wine;
                    sortedWines[arrayIndex].wineName = el.portfolioSummary[0].wineName;
                    sortedWines[arrayIndex].isEnPrimeur = el.portfolioSummary[0].isEnPrimeur || false;
                    sortedWines[arrayIndex].isSecondLabel = el.portfolioSummary[0].isSecondLabel;
                    sortedWines[arrayIndex].appellationId = el.portfolioSummary[0].appellationId;
                    sortedWines[arrayIndex].appellation = el.portfolioSummary[0].appellation;
                    sortedWines[arrayIndex].regionId = el.portfolioSummary[0].regionId;
                    sortedWines[arrayIndex].regionName = el.portfolioSummary[0].regionName;
                    sortedWines[arrayIndex].countryId = el.portfolioSummary[0].countryId;
                    sortedWines[arrayIndex].countryName = el.portfolioSummary[0].countryName;
                    sortedWines[arrayIndex].colorId = el.portfolioSummary[0].colorId;
                    sortedWines[arrayIndex].color = el.portfolioSummary[0].color;
                    sortedWines[arrayIndex].classification = el.portfolioSummary[0].classification;
                    sortedWines[arrayIndex].lastTraded = el.portfolioSummary[0].lastTraded;
                    sortedWines[arrayIndex].vintage = el.portfolioSummary[0].vintage;
                    sortedWines[arrayIndex].producerName = el.portfolioSummary[0].producerName;
                    sortedWines[arrayIndex].producerTypeName = el.portfolioSummary[0].producerTypeName;
                    sortedWines[arrayIndex].casesSizes = [];
                    sortedWines[arrayIndex].marketValue = {
                        calculationDate: el.marketValue.calculationDate,
                        investmentAmount: el.marketValue.investmentAmount,
                        marketValue: el.marketValue.marketValue,
                        numberOfBottles: el.marketValue.numberOfBottles,
                        performanceAmount: el.marketValue.performanceAmount,
                        performanceRate: el.marketValue.performanceRate,
                        wineVintageId: el.marketValue.wineVintageId,
                    };

                    for (let j = 0; j < this.wineList.length; j++) {
                        if (el.portfolioSummary[0].wineId === this.wineList[j].wine.wineId) {
                            sortedWines[arrayIndex].bottlePicture = this.wineList[j].wine.picture.bottlePicture;
                            break;
                        }
                    }

                    let newWineCase = {};
                    newWineCase.isFavourite = false;
                    newWineCase.size = el.portfolioSummary[0].size;
                    newWineCase.caseSizeId = el.portfolioSummary[0].caseSizeId;
                    newWineCase.wineId = el.portfolioSummary[0].wineId;
                    newWineCase.offersCases = el.portfolioSummary[0].offersCases;
                    newWineCase.bidsCases = el.portfolioSummary[0].bidsCases;
                    newWineCase.gain = el.portfolioSummary[0].gain;
                    newWineCase.averageBuyPrice = el.portfolioSummary[0].averageBuyPrice;
                    newWineCase.owned = el.portfolioSummary[0].owned;
                    sortedWines[arrayIndex].casesSizes.push(newWineCase);
                    arrayIndex++;
                } else {
                    let newWineCase = {};
                    newWineCase.isFavourite = false;
                    newWineCase.size = el.portfolioSummary[0].size;
                    newWineCase.caseSizeId = el.portfolioSummary[0].caseSizeId;
                    newWineCase.wineId = el.portfolioSummary[0].wineId;
                    newWineCase.offersCases = el.portfolioSummary[0].offersCases;
                    newWineCase.bidsCases = el.portfolioSummary[0].bidsCases;
                    newWineCase.gain = el.portfolioSummary[0].gain;
                    newWineCase.averageBuyPrice = el.portfolioSummary[0].averageBuyPrice;
                    newWineCase.owned = el.portfolioSummary[0].owned;

                    sortedWines[currWineIndex].casesSizes.push(newWineCase)
                }
            })

            for (let key in sortedWines) {
                for (let k = 0; k < sortedWines[key].casesSizes.length; k++) {
                    this.favWinesList.forEach(wine => {
                        if (sortedWines[key].casesSizes[k].wineId === wine.wineId && sortedWines[key].casesSizes[k].caseSizeId === wine.caseSizeId) {
                            sortedWines[key].casesSizes[k].isFavourite = true;
                        }
                    });
                }
            }
            return sortedWines;

        },
    },
    methods: {
        ...mapActions({
            loadWines: APortfolio.LOAD_WINES,
            loadNewSummary: APortfolio.GET_NEW_PORTFOLIO_SUMMARY,
            loadWinesSummary: APortfolio.GET_PORTFOLIO_SUMMARY,
            loadFavWines: AWines.GET_FAVOURITE_WINES,
            getOrders: AOrders.GET_ORDERS
        }),
        formatPrice(price) {
            return `€ ${price}`
        },
        activateGift() {
            this.$store.dispatch(AOrders.ACTIVATE_GIFT, this.giftCode).then((res) => {
                if (res.succeeded) {
                    this.activationSuccessful = true;
                    this.activationError = false;
                    this.loadWines();
                    this.loadWinesSummary();
                    this.loadFavWines();
                    this.getOrders();
                } else {
                    this.activationSuccessful = false;
                    this.activationError = true;
                }
            }).catch(() => {
                this.activationSuccessful = false;
                this.activationError = true;
            })
        },
        resetGiftModal(closeModal) {
            this.activationSuccessful = false;
            this.activationError = false;
            this.giftCode = '';

            if (closeModal) {
                this.giftModal = false
            }
        },
        formatDate(date) {
            return moment(date).locale(this.$i18n.locale).format('DD MMM YYYY')
        },
        selectWine(item, isBuy) {
            this.wineId = item.wineId;
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS);
            this.$router.push(this.localePath({path: (isBuy ? '/wine-trading-buy/' : '/wine-trading-sell/') + item.wineId}));
        },
        goToLogin() {
            this.$router.push(this.localePath({path: '/login'}));
        },
        toggleFav(event, wine) {
            event.stopPropagation();
            let currWineId = wine.wineId;
            let currWineCaseSizeId = wine.caseSizeId;

            this.$store.dispatch(AWines.SWITCH_WINE_FAVOURITE, {wineId: wine}).then(x => {
                this.$store.dispatch(AWines.GET_FAVOURITE_WINES).then(
                    this.filteredItems.forEach(wine => {
                        if (wine.wineId === currWineId) {
                            let isWineInFavourites = false;

                            this.favWinesList.forEach(wine => {
                                if (currWineId === wine.wineId && currWineCaseSizeId === wine.caseSizeId) {
                                    isWineInFavourites = true;
                                }
                            });

                            wine.isFavourite = isWineInFavourites;
                            return true
                        }
                    })
                )
            });
        },
        goToWineDetails(item) {
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.casesSizes[0].caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                if (item.wineName) {
                    this.$router.push(this.localePath({path: '/wine-details/' + item.wineId + '/' + item.casesSizes[0].caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + item.classification.toLowerCase().split(' ').join('-') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.wineName.toLowerCase().split(' ').join('-') + '-' + item.producerName.toLowerCase().split(' ').join('-') + '-' + item.producerTypeName.toLowerCase().split(' ').join('-')}));
                } else {
                    this.$router.push(this.localePath({path: '/wine-details/' + item.wineId + '/' + item.casesSizes[0].caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + item.classification.toLowerCase().split(' ').join('-') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-') + '-' + item.producerTypeName.toLowerCase().split(' ').join('-')}));
                }
            })
        },
        openWinePerformance(location = "", item) {
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: (item.wineVintageId ? item.wineVintageId : item.wineId),
                caseSize: (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId),
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({path: '/wine-performance/' + (item.wineVintageId ? item.wineVintageId : item.wineId) + '/' + (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId) + '/' + (typeof item.appellation !== 'undefined' && item.appellation ? item.appellation.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.classification !== 'undefined' && item.classification) ? item.classification.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.color !== 'undefined' && item.color) ? item.color.toLowerCase() : "") + '-' + ((typeof item.producerName !== 'undefined' && item.producerName) ? item.producerName.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.producerTypeName !== 'undefined' && item.producerTypeName) ? item.producerTypeName.toLowerCase().split(' ').join('-') : "")}));
            })
        },
    },
    created() {
        this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
            this.isLogged = true;
            this.loadWines();
            this.loadWinesSummary();
            this.loadNewSummary();
            this.loadFavWines();
            this.getOrders();
        }).catch((err) => {
            this.isLogged = false;
        });
    }
}
</script>

<style scoped>
.mobile-wines-body {
    width: 100%;
}

.addition-description {
    font-family: Roboto, sans-serif;
    font-weight: normal;
    font-size: 18px;
    margin-top: 6px;
    margin-bottom: 0;
    color: var(--black);
}

.wine-enprimeur {
    background: #E2C477;
    text-align: center;
    width: 86px;
    height: 22px;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.88);
    padding: 0;
    border-radius: 4px;
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
    z-index: 9999;
}

.mobile-wines-header {
    width: 100%;
    padding: 0 0 10px;
    display: flex;
    flex-wrap: wrap;
}

.mobile-wines-header div {
    color: rgba(0, 0, 0, 0.64);
    font-size: var(--fs-small);
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    height: 20px;
    white-space: nowrap;
    display: inline-block;
    width: 33.33%;
}

.mobile-wines-header.de div,
.mobile-wines-header.it div {
    margin: 7px 0;
    color: rgba(0, 0, 0, 0.64);
    font-size: var(--fs-small);
    font-weight: 300;
    box-shadow: none !important;
    height: 20px;
    display: inline-block;
    width: 33.33%;
    line-height: 15px;
    white-space: break-spaces;
}

.mobile-wines-row {
    display: flex;
    flex-wrap: wrap;
    padding: 15px 0;
    border-top: 1px solid #b2b2b2;
}

.mobile-wines-row:nth-child(even) {
    background: var(--semi-white);
}

.mobile-wines-div {
    display: inline-block;
    width: 33.33%;
    vertical-align: top;
    padding: 5px 0;
    font-weight: 600;
    color: var(--black)
}

.mobile-wines-div.cta-button {
    flex: 1;
}

.mobile-wines-div.cta-button.left {
    margin-right: 5px;
}

.mobile-wines-div.cta-button.right {
    margin-left: 5px;
}

.gift-btn {
    position: absolute;
    right: 0;
    font-size: 16px;
    height: 32px;
    background: #f6f6f6;
    border-radius: 6px;
    padding: 4px 36px 6px 12px;
    top: 0;
    font-weight: 400;
    z-index: 3;
}

.gift-btn svg {
    position: absolute;
    right: 6px;
    fill: #707070;
}

.gift-btn:hover {
    cursor: pointer;
}

.gift-btn:active,
.gift-btn:focus {
    opacity: 0.7;
}

.gift-icon {
    width: 60px;
    height: 60px;
    margin: 0 auto;
}

.gift-icon svg {
    width: 100%;
    height: 100%;
    fill: #707070;
}

.gift-code {
    max-width: 320px;
    margin: 0 auto;
}

.bids-offers-modal h3 {
    margin-bottom: 16px;
    font-size: var(--fs-large);
}

.goto-market-btn {
    margin-top: 32px;
}

.btn-bid-proceed {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background: var(--brand);
    color: #ffffff;
}

.btn-bid-cancel {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}

.btn-bid-cancel:hover {
    color: #ffffff;
}

.bids-offers-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}

.bids-offers-modal .warning-icon {
    background: url('../assets/report_problem-24px.svg') no-repeat center;
    background-size: contain;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.bids-title svg {
    margin-right: 5px;
    fill: #707070;
    position: relative;
    top: 4px
}

.offers-title svg {
    margin-right: 5px;
    fill: #707070;
    position: relative;
    top: 4px
}

.cancel-bid-body {
    text-align: center;
    justify-content: center;
    font-size: var(--fs-base);
}

.wine-details-head {
    display: block;
    width: 100%;
}

h3 {
    color: #707070;
    margin-bottom: calc(2 * var(--gutter));
}

h4 {
    color: #707070;
    margin-top: var(--gutter);
    margin-bottom: 3px;
}

.market-btn-col {
    width: 100px;
}

.half-padding-left {
    padding-left: calc(0.5 * var(--gutter));
}

.no-padding-right {
    padding-right: 0;
}

.half-padding-right {
    padding-right: calc(0.5 * var(--gutter));
}

.trading-desk-container1 {
    height: 100%;
}

.trading-desk-container1 .v-card__text {
    height: 100%;
    padding-bottom: 0;
}

.trading-desk-table-tabs {
    padding: 0 15px;
    height: 100%;
}

.trading-desk-table-tabs .v-tabs-bar {
    background-color: #F9F9F9 !important;
}

.trading-desk-table-tabs .theme--light.v-tabs-items {
    height: calc(100% - 50px);
    background: #FFFFFF;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
}

.loading-screen {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #FFF;
    z-index: 10;
}

.loading-gif {
    margin: 200px auto;
    width: 200px;
    height: 200px;
}

.portfolio-table {
    margin: 0;
    background-color: transparent;
    box-shadow: none !important;
}

.wine-market-table-header-ctrls {
    height: 75px;
    padding-top: 5px;
    background: #ffffff;
    border-bottom: 1px solid #EAEEF1;
}

.winemarket-search-filter {
    width: calc(100% - 30px);
    display: inline-block;
    border-radius: 3px;
    text-indent: 48px;
    padding-left: 25px;
    background: url('../assets/search_icon.png') no-repeat 40px 16px;
}

.wine-market-wrapper {
    height: 100%;
    padding-bottom: 32px;
    position: relative;
}

.winemarket-change.negative {
    color: #da443d;
}

.winemarket-change.negative div {
    width: 20px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    margin-left: 5px;
    position: relative;
    background: url('../assets/sprite-web.png') no-repeat -60px -507px;
}

.winemarket-change.positive {
    color: #3BC34F;
}

.winemarket-change.positive div {
    width: 20px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    margin-left: 5px;
    position: relative;
    background: url('../assets/sprite-web.png') no-repeat -60px -456px;
}

.winemarket-winecolor-img {
    width: 20px;
    height: 45px;
    position: relative;
    background: url('../assets/sprite-web.png') no-repeat -17px -544px;
    position: relative;
}

.winemarket-winecolor-img.redwine {
    background: url('../assets/red.png') no-repeat center right;
    background-size: contain;
}

.winemarket-winecolor-img.whitewine {
    background: url('../assets/sprite-web.png') no-repeat -17px -444px;
    background-size: contain;
}

.winecolor-tooltip {
    width: 80px;
    height: 25px;
    color: #182730;
    font-size: 13px;
    font-weight: 400;
    top: -15px;
    left: 8px;
    position: relative;
    background: #f9f9f9;
    border-radius: 5px;
    text-align: center;
    line-height: 25px;
    -webkit-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
    display: none;
}

.winemarket-winecolor-img:hover .winecolor-tooltip {
    display: block;
}

.v-data-table tr:hover,
.v-data-table td:hover {
    cursor: pointer;
}

.order-success-text {
    text-align: center;
}

.close-order-success-modal {
    margin: 0 auto;
}

.show-hide-ctrl:hover {
    cursor: pointer;
    background-position-x: -41px;
}

.country-fr {
    background: url('../assets/france.png') no-repeat center;
    width: 30px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    margin-right: 5px;
    position: relative;
}

.wine-star {
    width: 33px;
    height: 33px;
    background: url('../assets/star-not-selected.svg') no-repeat center !important;
    background-size: contain;
    display: block;
}

.wine-star:focus,
.wine-star:active {
    outline: none;
}

.wine-star.active {
    background: url('../assets/star-selected.svg') no-repeat center !important;
    background-size: contain;
}

.portfolio-wrapper h2 {
    color: var(--black);
    margin-top: 7px;
    margin-bottom: 20px;
    padding: 0;
}

.wine-details-head h2:hover {
    color: var(--brand);
    cursor: pointer;
}

.portfolio-wrapper .portfolio-row {
    margin-top: 64px;
}

.market-btn {
    width: 125px;
    font-weight: 300;
    text-align: center;
    line-height: 1em;
    height: 32px;
}

.portfolio-wrapper .second-row {
    font-weight: 300;
    line-height: 20px;
    color: #555555;
    margin: var(--gutter) 0 calc(2 * var(--gutter));
}

.portfolio-wrapper .last-trade-el {
    display: inline-block;
}

.portfolio-wrapper .my-investments {
    border-radius: 8px;
    background-color: #E1C376;
    padding: 22px 50px;
    display: flex;
}

.portfolio-wrapper .my-investments .investments-item {
    text-align: right;
    border-right: 1px solid #FADF95;
    padding-right: 15px;
    padding-left: 20px;
}

.portfolio-wrapper .my-investments .investments-label {
    color: #FBEAC0;
    margin-bottom: 5px;
}

.portfolio-wrapper .my-investments .bold {
    color: #fff;
    font-weight: 600;
    font-size: 36px;
}

.portfolio-wrapper .wine-details-img {
    width: 30px;
    height: 19px;
    border: 1px solid #DEE2E4;
    position: relative;
    top: 2px;
    margin-right: 10px;
}

.wine-summary-wrapper {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 8px;
    margin-top: 13px;
    margin-bottom: 13px;
    display: flex;
    flex-wrap: wrap;
}

.wine-summary-row {
    width: 50%;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding-left: 0;
    border: 0;
}

.wine-summary-row:nth-child(1),
.wine-summary-row:nth-child(2) {
    margin-bottom: 10px;
}

.wine-summary-row.last-child {
    max-width: 100%;
    width: 100%;
    margin-top: 10px;
}

.wine-summary-row-title {
    color: rgba(0, 0, 0, 0.64);
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 4px;
}

.wine-summary-row-value {
    font-size: 18px;
    line-height: 29px;
    color: rgba(0, 0, 0, 0.88);
    font-weight: 600;
}

.wine-summary-row-value1, .wine-summary-row-value2, .wine-summary-row-value3 {
    display: inline-block;
}

.wine-summary-row-value1 {
    margin-right: 5px;
}

.wine-summary-row-value3.up {
    width: 16px;
    height: 17px;
    background: url('../assets/price-up.png') no-repeat center;
}

.wine-summary-row-value3.down {
    width: 16px;
    height: 17px;
    background: url('../assets/price-down.png') no-repeat center;
}

.perform-btn {
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    border: 1px solid var(--light-gray);
    border-radius: 4px;
    text-align: center;
    padding: 10px;
    margin-top: 4px;
}

.perform-btn:hover {
    cursor: pointer;
}

.wine-star {
    margin: 0;
}

.info-text {
    background: #303030;
    border-radius: 6px;
    padding: 6px;
    color: #ffffff;
    text-align: center;
    font-size: 14px;
    position: absolute;
    right: -45px;
    height: 65px;
    margin-top: -98px;
    white-space: pre-line;
    display: none;
}
.info-text:before {
    content: "";
    position: absolute;
    top: 100%;
    right: 75px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-top: 10px solid #303030;
    border-right: 7px solid transparent;
}

.wine-enprimeur:hover {
    cursor: pointer;
}
.wine-enprimeur:hover .info-text {
    display: flex;
    align-items: center;
}

@media (max-width: 767px) {
    .portfolio-wrapper .my-investments {
        padding: 20px 13px;
        flex-wrap: wrap;
    }

    .portfolio-wrapper h2 {
        font-size: 20px;
        line-height: 22px;
    }

    .portfolio-wrapper .wine-details-img {
        width: 23px;
        height: 15px;
    }

    .portfolio-wrapper .second-row {
        margin-top: 0;
    }

    .market-btn {
        width: 100%;
    }

    .portfolio-wrapper .my-investments .bold {
        font-size: 15px;
    }

    .portfolio-wrapper .my-investments .investments-item {
        display: inline-block;
        width: 50%;
        padding-left: 0;
    }

    .portfolio-wrapper .my-investments .investments-item:nth-child(2) {
        border: 0;
        padding: 0;
    }

    .portfolio-wrapper .my-investments .investments-item:nth-child(3) {
        padding-top: 15px;
    }

    .portfolio-wrapper .my-investments .investments-item:nth-child(4) {
        padding-top: 15px;
        border: 0;
    }

    .portfolio-wrapper .my-investments .investments-item.total-gain {
        border-right: 0;
        padding-right: 0;
    }

    .portfolio-wrapper .my-investments .investments-item .rate-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .portfolio-wrapper .my-investments .investments-label {
        line-height: 15px;
        margin-bottom: 2px;
    }

    .portfolio-wrapper .portfolio-row {
        margin-top: 30px;
        background-color: #FFF;
        border-radius: 8px;
        padding: 8px;
    }

    .gift-btn {
        position: relative;
        width: 185px;
        margin: 15px auto;
    }

    .portfolio-wrapper .my-investments .bold,
    .portfolio-wrapper .my-investments .regular,
    .portfolio-wrapper .my-investments .performance {
        display: inline-block;
    }

    .portfolio-wrapper .my-investments .performance {
        margin-left: 5px;
    }

    .portfolio-wrapper .my-investments .regular {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-size: 14px;
        line-height: 29px;
        color: #ffffff;
        margin-left: 5px;
    }

    .performance.up {
        background: url('../assets/price-upw.png') no-repeat center;
        width: 10px;
        height: 11px;
    }
}
</style>

<style>
.bids-offers-modal .v-card__title,
.bids-offers-modal .v-card__actions {
    justify-content: center;
}

.offers-table .hyperlink-td,
.bids-table .hyperlink-td {
    float: right;
}

.footer-info-text div {
    display: inline-block;
    margin-right: 25px;
}

.portfolio-wrapper .theme--light.v-data-table tbody tr td .dots {
    display: inline-block;
    width: 8px;
    height: 18px;
    margin: 0;
    background: url('../assets/dots-only-for-example.png') no-repeat center;
    background-size: contain;
    cursor: pointer;
    position: relative;
    top: 2px;
}

.portfolio-wrapper .theme--light.v-data-table thead tr th.gain-th:after {
    content: '';
    width: 15px;
    height: 15px;
    background: url('../assets/info-icon-for-example.png') no-repeat center;
    position: absolute;
    right: -15px;
    top: 15px;
    background-size: cover;
}

.portfolio-wrapper .v-data-table {
    box-shadow: none !important;
    width: 100%;
}

.portfolio-wrapper .last-trade-el-class {
    margin: 0 calc(1.5 * var(--gutter));
}

.portfolio-wrapper .winemarket-winecolor-img {
    display: inline-block;
    width: 20px;
    height: 16px;
    position: relative;
    margin: 0 0 0 calc(1.5 * var(--gutter));
    background: url('../assets/rose.png') no-repeat center;
    background-size: contain;
}

.portfolio-wrapper .winemarket-winecolor-img.redwine {
    background: url('../assets/red.png') no-repeat center;
    background-size: contain;
}

.portfolio-wrapper .winemarket-winecolor-img.whitewine {
    background: url('../assets/white.png') no-repeat center;
    background-size: contain;
}

.portfolio-wrapper .wine-details-region {
    max-width: var(--container-width);
}

.portfolio-wrapper .theme--light.v-data-table.v-data-table--fixed-header.default-table thead th {
    padding-bottom: 0;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tabs-bar {
    max-width: 100%;
    background: var(--semi-white);
    padding: 0;
    height: 48px;
}

.portfolio-tabs .v-tabs-slider {
    background-color: transparent;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tab {
    background: #F5F6F5;
    text-transform: capitalize;
    color: rgba(0, 0, 0, .64);
    font-weight: 700;
    font-size: calc(var(--fs-base) - 2px);
    min-width: 120px;
    padding: 0 16px;
    text-transform: uppercase;
    border-bottom: 1px solid #B9BAB9;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tab.v-tab--active {
    border: 0;
    background: var(--semi-white);
    border-bottom: 4px solid var(--blue);
    position: relative;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tab.v-tab--active:after {
    content: '';
    width: 100%;
    position: absolute;
    background: #fff;
    height: 1px;
    bottom: -1px;
    left: 0;
}

.my-profile-card .my-profile-vertical-tabs .portfolio-tabs .v-slide-group__content .v-tabs-slider-wrapper {
    border-bottom: 1px solid #B9BAB9;
    display: block;
    width: 100% !important;
}

.theme--light.v-data-table .v-data-table-header th.sortable[aria-sort="none"] .v-icon {
    display: none;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table thead th:hover {
    color: var(--blue) !important;
    cursor: default;
}

.my-profile-vertical-tabs .portfolio-tabs .v-window.v-item-group.theme--light {
    padding: 0;
}
</style>
